import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ManageConnectionProfiles from "./ManageConnectionProfiles";
import { fetchProfileList } from 'redux/profiles/ProfilesActions';

const mapStateToProps = ({ profiles }) => ({
  fetchingProfilesList: profiles.fetchingProfilesList,
  profilesList: profiles.profilesList,
});

const mapDispatchToProps = dispatch => ({
  profilesActions: bindActionCreators({ fetchProfileList }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageConnectionProfiles);




// WEBPACK FOOTER //
// ./src/components/manageConnection/comp/connectionEditor/ManageConnectionProfilesConnector.js